var $23330ac977b86c37$exports = {};
function $23330ac977b86c37$var$sent(key) {
    fetch('https://api.clubedotruco.com.br/fingerprint', {
        method: 'GET',
        headers: {
            'Affiliate-Code': key,
            'User-Search': window.location.search
        }
    });
}
var $23330ac977b86c37$var$url = new URL(window.location.href);
var $23330ac977b86c37$var$p = $23330ac977b86c37$var$url.searchParams.get('i') || $23330ac977b86c37$var$url.searchParams.get('pid');
function $23330ac977b86c37$var$cc(n, v) {
    var date = new Date();
    date.setDate(date.getDate() + 30);
    document.cookie = `${n}=${v}; domain=.clubedotruco.com.br; path=/; expires=${date.toUTCString()}`;
}
if ($23330ac977b86c37$var$p && $23330ac977b86c37$var$p.length === 6) {
    $23330ac977b86c37$var$sent($23330ac977b86c37$var$p);
    $23330ac977b86c37$var$cc('pid', $23330ac977b86c37$var$p);
}


//# sourceMappingURL=como-jogar-nossos-campeonatos-de-truco-online.f36609ed.js.map
